// Toast notification shown when an achievement is unlocked.
// Queues multiple unlocks; each shows for 3.5 s with a slide-in/out animation.

import type { AchievementDef } from "../game/achievements";

let queue: AchievementDef[] = [];
let el: HTMLDivElement | null = null;
let showing = false;

function getEl(): HTMLDivElement {
  if (!el) {
    el = document.createElement("div");
    el.className = "ach-toast";
    document.body.appendChild(el);
  }
  return el;
}

function showNext(): void {
  if (showing || queue.length === 0) return;
  showing = true;
  const def = queue.shift()!;
  const toast = getEl();

  toast.innerHTML = `
    <div class="ach-toast-badge">${def.icon}</div>
    <div class="ach-toast-body">
      <div class="ach-toast-label">ACHIEVEMENT UNLOCKED</div>
      <div class="ach-toast-title">${def.title}</div>
      <div class="ach-toast-desc">${def.description}</div>
    </div>`;

  toast.classList.remove("ach-toast-out");
  toast.classList.add("ach-toast-in");

  setTimeout(() => {
    toast.classList.remove("ach-toast-in");
    toast.classList.add("ach-toast-out");
    setTimeout(() => {
      showing = false;
      showNext();
    }, 400);
  }, 3500);
}

export function showAchievementNotification(def: AchievementDef): void {
  queue.push(def);
  showNext();
}
